module.exports = __webpack_public_path__ + "img/work-slide-06-small.866919a6.jpg";